import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import Select from 'react-select'
import FilterPagination from 'pages/parts/FilterPagination'
import { Dropdown, Modal } from 'react-bootstrap'
import DatePicker from 'react-datepicker'

import { GET, httpOk } from 'helpers/api'
import { checkFilter, chequeDates, formatDate, formatMoney, getCurrentChequeDate } from 'helpers/helpers'

function Sales() {
	const { t } = useTranslation()

	const date = new Date()
	const initialFilter = {
		start_date: formatDate(new Date(date.getFullYear(), date.getMonth(), 1), 'yyyy-MM-dd'),
		end_date: formatDate(new Date(), 'yyyy-MM-dd'),
		pos_id: null,
		search: ''
	};

	const [data, setData] = useState([])
	const [totalSales, setTotalSales] = useState(0)
	const [showModal, setShowModal] = useState({ show: false, data: {} })

	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [filterDataExist, setFilterDataExist] = useState(false)
	const [filterData, setFilterData] = useState({ ...initialFilter })
	const [pagination, setPagination] = useState({
		url: `/shifts/`,
		response: null
	})

	async function toggleModal(bool, item, product_type, mode = 'products') {
		if (bool) {
			const params = { ...filterData, cashier_login: item.login }
			if (product_type) params.product_type = product_type // faqat aniq tur; foyda modali barcha turlarni oladi
			const response = await GET('/report/cashiers/history', params, { loader: true })
			if (httpOk(response)) {
				setShowModal({ show: true, data: response.data, mode })
				setPagination({ ...pagination, 'response': response.data })
			}

		} else {
			setShowModal({ ...showModal, show: false })
		}
	}

	function resetFilter() {
		setFilterData({ ...initialFilter })
	}

	async function selectChequeDates(option) {
		const result = getCurrentChequeDate(option.id)
		setFilterData({ ...filterData, ...result, 'dateType': option.id })
	}

	async function getData() {
		setFilterDataExist(checkFilter(filterData, initialFilter));

		const response = await GET("/report/cashiers", filterData, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			const rows = response.data?.data ?? []
			const sum = rows.reduce((acc, item) => acc + parseFloat(item.total_amount ?? 0), 0)
			setTotalSales(sum)
			setPagination({ ...pagination, 'response': response.data })
			if (dropdownIsOpen) setDropdownIsOpen(false)
		}
	}

	async function paginate(page, size) {
		setFilterData({ ...filterData, 'page': page, 'size': size })
	}


	useEffect(() => {
		getData()
	}, [filterData.page, filterData.size]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<style>{`
				.cashiers-table { font-size: 13px; }
				.cashiers-table th { font-weight: 600; white-space: nowrap; vertical-align: middle; }
				.cashiers-table td { white-space: nowrap; }
				.cashiers-table tbody tr:hover { background-color: #f8f9fb; }
				.cashiers-table .cursor:hover { text-decoration: underline; }
			`}</style>

			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('cashiers')} [{data.total}]
				</h4>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between mb-3">
						<div className="d-flex gap-2">
							<div>
								<Dropdown onToggle={() => setDropdownIsOpen(!dropdownIsOpen)} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-4">
												<label>{t('period')}</label>
												<Select
													options={chequeDates}
													value={chequeDates.find(option => option.id === filterData.dateType) || ''}
													onChange={(option) => selectChequeDates(option)}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>

											<div className="form-group col-md-4">
												<label className="invisible">{t('period')}</label>
												<div className="calendar-input">
													<DatePicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.start_date ? new Date(filterData.start_date) : ''}
														onChange={(date) => setFilterData({ ...filterData, 'start_date': formatDate(date, 'yyyy-MM-dd') })} />
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
											<div className="form-group col-md-4">
												<label className="invisible">.</label>
												<div className="calendar-input">
													<DatePicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.end_date ? new Date(filterData.end_date) : ''}
														onChange={(date) => setFilterData({ ...filterData, 'end_date': formatDate(date, 'yyyy-MM-dd') })} />
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
										</div>

										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end gap-2">
													<button className="btn btn-secondary" onClick={() => setDropdownIsOpen(false)}>{t('cancel')}</button>
													<button className="btn btn-primary" onClick={() => getData()}>{t('apply')}</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{(filterData.start_date || filterData.end_date) &&
									<span className="me-2">
										<b>{t('period')}: </b>
										{filterData.start_date &&
											<span>{formatDate(filterData.start_date)}</span>
										}
										{(filterData.start_date && filterData.end_date) &&
											<span>|</span>
										}
										{filterData.end_date &&
											<span>{formatDate(filterData.end_date)}</span>
										}
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>{t('reset')}</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered table-hover align-middle mb-0 cashiers-table">
							<thead className="table-light">
								<tr>
									<th style={{ 'minWidth': '33px' }}>#</th>
									<th style={{ 'width': '10%' }}>{t('login')}</th>
									<th style={{ 'width': '10%' }}>{t('name2')}</th>
									<th style={{ 'minWidth': '60px' }} className="text-end">{t('cheques')}</th>
									<th style={{ 'minWidth': '90px' }} className="text-end">{t('average_cheque')}</th>
									<th style={{ 'minWidth': '65px' }} className="text-end text-muted">{t('profiled_sheeting')}</th>
									<th style={{ 'minWidth': '65px' }} className="text-end text-muted">{t('accessory')}</th>
									<th style={{ 'minWidth': '65px' }} className="text-end text-muted">{t('tunikofon')}</th>
									<th style={{ 'minWidth': '65px' }} className="text-end text-muted">{t('products')}</th>
									<th style={{ 'minWidth': '95px' }} className="text-end">{t('debt_given')}</th>
									<th style={{ 'width': '7%' }} className="text-end">{t('discount_amount')}</th>
									<th style={{ 'width': '10%' }} className="text-end">{t('sale_amount')}</th>
									<th style={{ 'minWidth': '110px' }} className="text-end">{t('profit')}</th>
									<th style={{ 'width': '6%' }} className="text-center">{t('share')}</th>
									<th style={{ 'minWidth': '115px' }} className="text-end">⚠️ {t('deleted_cheques')}</th>

								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => {
									const share = totalSales > 0 ? (parseFloat(item.total_amount) / totalSales * 100).toFixed(1) : 0
									const avgCheque = Number(item.total_cheques) > 0 ? parseFloat(item.total_amount) / Number(item.total_cheques) : 0
									const margin = parseFloat(item.total_amount) > 0 ? (parseFloat(item.total_profit) / parseFloat(item.total_amount) * 100).toFixed(1) : 0
									const profitClass = parseFloat(item.total_profit) >= 0 ? 'text-success' : 'text-danger'
									const marginBadge = parseFloat(margin) >= 15 ? 'bg-success' : parseFloat(margin) >= 8 ? 'bg-warning text-dark' : 'bg-light text-dark border'
									return (
										<tr key={index}>
											<td className="text-muted">{item.row_number}</td>
											<td className="fw-500">{item.login}</td>
											<td className="td-ellipsis text-muted">{item.name}</td>
											<td className="text-end">{formatMoney(item.total_cheques, 2)}</td>
											<td className="text-end">{formatMoney(avgCheque)}</td>
											<td className="text-end text-muted cursor" onClick={() => toggleModal(true, item, 4)}>{formatMoney(item.products_type_4, 2)}</td>
											<td className="text-end text-muted cursor" onClick={() => toggleModal(true, item, 3)}>{formatMoney(item.products_type_3, 2)}</td>
											<td className="text-end text-muted cursor" onClick={() => toggleModal(true, item, 5)}>{formatMoney(item.products_type_5, 2)}</td>
											<td className="text-end text-muted cursor" onClick={() => toggleModal(true, item, 1)}>{formatMoney(item.products_type_1, 2)}</td>
											<td className="text-end" style={{ color: '#d97706' }}>{Number(item.total_debt) > 0 ? formatMoney(item.total_debt, 2) : <span className="text-muted">0</span>}</td>
											<td className="text-end text-muted">{formatMoney(item.total_discount, 2)}</td>
											<td className="text-end fw-bold">{formatMoney(item.total_amount, 2)}</td>
											<td className="text-end cursor" onClick={() => toggleModal(true, item, null, 'profit')}>
												<div className={'fw-bold ' + profitClass}>{formatMoney(item.total_profit, 2)}</div>
												<span className={'badge ' + marginBadge}>{margin}%</span>
											</td>
											<td className="text-center">
												<span className={`badge ${parseFloat(share) >= 20 ? 'bg-success' : parseFloat(share) >= 5 ? 'bg-warning text-dark' : 'bg-light text-dark border'}`}>
													{share}%
												</span>
											</td>
											<td className="text-end">
												{Number(item.deleted_count) > 0
													? <span className="badge bg-danger">{item.deleted_count} {t('pieces')} · {formatMoney(item.deleted_amount)}</span>
													: <span className="text-muted">0</span>
												}
											</td>
										</tr>
									)
								})}
							</tbody>
							{data?.data?.length > 0 &&
								<tfoot className="table-secondary fw-bold">
									<tr>
										{(() => {
											const totalCheques = data.data.reduce((s, i) => s + parseFloat(i.total_cheques ?? 0), 0)
											const avgAll = totalCheques > 0 ? totalSales / totalCheques : 0
											const totalProfit = data.data.reduce((s, i) => s + parseFloat(i.total_profit ?? 0), 0)
											const marginAll = totalSales > 0 ? (totalProfit / totalSales * 100).toFixed(1) : 0
											return (
												<>
													<td colSpan="3" className="fw-bold">{t('total')}</td>
													<td className="text-end fw-bold">{formatMoney(totalCheques, 2)}</td>
													<td className="text-end fw-bold">{formatMoney(avgAll)}</td>
													<td className="text-end fw-bold">{formatMoney(data.data.reduce((s, i) => s + parseFloat(i.products_type_4 ?? 0), 0), 2)}</td>
													<td className="text-end fw-bold">{formatMoney(data.data.reduce((s, i) => s + parseFloat(i.products_type_3 ?? 0), 0), 2)}</td>
													<td className="text-end fw-bold">{formatMoney(data.data.reduce((s, i) => s + parseFloat(i.products_type_5 ?? 0), 0), 2)}</td>
													<td className="text-end fw-bold">{formatMoney(data.data.reduce((s, i) => s + parseFloat(i.products_type_1 ?? 0), 0), 2)}</td>
													<td className="text-end fw-bold" style={{ color: '#d97706' }}>{formatMoney(data.data.reduce((s, i) => s + parseFloat(i.total_debt ?? 0), 0), 2)}</td>
													<td className="text-end fw-bold">{formatMoney(data.data.reduce((s, i) => s + parseFloat(i.total_discount ?? 0), 0), 2)}</td>
													<td className="text-end fw-bold">{formatMoney(totalSales, 2)}</td>
													<td className="text-end fw-bold">
														<div className={totalProfit >= 0 ? 'text-success' : 'text-danger'}>{formatMoney(totalProfit, 2)}</div>
														<span className="badge bg-secondary">{marginAll}%</span>
													</td>
													<td className="text-center fw-bold">100%</td>
													<td className="text-end fw-bold text-danger">
														{data.data.reduce((s, i) => s + parseInt(i.deleted_count ?? 0), 0)} {t('pieces')} · {formatMoney(data.data.reduce((s, i) => s + parseFloat(i.deleted_amount ?? 0), 0))}
													</td>
												</>
											)
										})()}
									</tr>
								</tfoot>
							}
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={paginate}>
						</FilterPagination>
					}
				</div>
			</div>

			<Modal show={showModal.show} animation={false} centered dialogClassName="update-modal-width"
				onHide={() => toggleModal(false)} size="xl">
				<Modal.Header closeButton>
					<Modal.Title>
						{showModal.data.cashier_login} {showModal.mode === 'profit'
							? `— ${t('profit')}: ${formatMoney(showModal?.data?.data?.reduce((s, i) => s + parseFloat(i.profit ?? 0), 0))}`
							: `[${formatMoney(showModal.data.total_metr_sold)}]`
						}
					</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '5%' }} className="text-start">{t('cheque')} ID</th>
									<th style={{ 'width': '25%' }}>{t('product_name')}</th>
									<th style={{ 'width': '10%' }} className="text-center">{t('date')}</th>
									<th style={{ 'width': '8%' }} className="text-end">{t('quantity')}</th>
									<th style={{ 'width': '8%' }} className="text-end">{t('size')}</th>
									<th style={{ 'width': '8%' }} className="text-end">{t('metr')}</th>
									<th style={{ 'width': '8%' }} className="text-end">{t('price')}</th>
									<th style={{ 'width': '10%' }} className="text-end">{t('amount')}</th>
									{showModal.mode === 'profit' && <th style={{ 'width': '10%' }} className="text-end text-success">{t('profit')}</th>}
								</tr>
							</thead>
							<tbody>
								{showModal?.data?.data?.map((item, index) => (
									<tr className="tr-middle" key={index}>
										<td className="text-center">{index + 1}</td>
										<td className="text-start">{item.cheque_id}</td>
										<td>{item.name}</td>
										<td className="text-center">{formatDate(item.cheque_closed_at)}</td>
										<td className="text-end">{formatMoney(item.quantity, 2)}</td>
										<td className="text-end">{formatMoney(item.element_quantity, 2)}</td>
										<td className="text-end">{formatMoney(item.metr, 2)}</td>
										<td className="text-end">{formatMoney(item.sale_price)}</td>
										<td className="text-end">{formatMoney(item.total_price)}</td>
										{showModal.mode === 'profit' && <td className="text-end text-success fw-bold">{formatMoney(item.profit)}</td>}
									</tr>
								))}
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={paginate}>
						</FilterPagination>
					}
				</Modal.Body>
			</Modal>
		</>
	)
}

export default Sales